// extracted by mini-css-extract-plugin
export default {"root":"Pp2eO0NQL8HUpoXHszT7","placeHolderShimmer":"x3UgSnCTqURAtgKUjcwH"};